module.exports = __webpack_public_path__ + "img/ny-ven-paa-fb-1.38c3c03f.png";